import { css } from '@emotion/react';

import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import CopyToClipboardButton from 'components/CopyToClipboardButton/CopyToClipboardButton';

import { useState, ReactNode } from 'react';

interface IProps {
  summary: string;
  contentPlaceholder: ReactNode;
  renderContent: () => ReactNode;
  copyJson?: unknown;
  copyText?: string;
}

export default function ExpandableDetails({ summary, contentPlaceholder, renderContent, copyJson, copyText }: IProps) {
  const [open, setOpen] = useState(false);
  const text = copyText ?? (copyJson === undefined ? undefined : JSON.stringify(copyJson, null, 2));

  return (
    <Typography
      component="div"
      variant="body1"
      css={css`
        details summary {
          display: inline-flex;
          align-items: center;
          width: fit-content;
          padding: 8px 8px 8px 4px;
          margin: 3px 3px 3px -4px;
          letter-spacing: 0.5px;
          cursor: pointer;
          list-style: none;
        }
        details summary::-webkit-details-marker,
        details summary::marker {
          display: none;
        }
        details summary .expand-icon {
          font-size: 20px;
          margin-right: 2px;
          transition: transform 0.15s ease;
        }
        details[open] summary .expand-icon {
          transform: rotate(180deg);
        }
      `}
    >
      <details
        onToggle={(event) => {
          setOpen(event.currentTarget.open);
        }}
      >
        <summary>
          <ExpandMoreIcon className="expand-icon" />
          {summary}
          {text !== undefined && (
            <span
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
            >
              <CopyToClipboardButton data={text} size="small" subject={summary} />
            </span>
          )}
        </summary>
        {open ? renderContent() : contentPlaceholder}
      </details>
    </Typography>
  );
}
